// Converts a USD string (e.g., "$1,234.56") to a plain numeric string (e.g., "1234.56")
export function usdToPlainString(usd: string): string {
  if (!usd) return '0';
  // Remove $ , and spaces, handle parentheses for negatives
  const cleaned = usd.replace(/[^0-9.()-]+/g, '');
  let num = cleaned;
  if (cleaned.includes('(') && cleaned.includes(')')) {
    num = '-' + cleaned.replace(/[()]/g, '');
  }
  return num.replace(/^(-?)(0+)(\d)/, '$1$3'); // Remove leading zeros
}

export const numberToUSDCurrency = (value?: string | number | null) => {
  if (value === undefined || value === null || value === '') return '—';

  const normalizedValue = typeof value === 'string' ? value.trim() : value;
  if (normalizedValue === '') return '—';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(Number(normalizedValue));
};

